import React from 'react'
import { Modal } from '@material-ui/core'
import { BaSeButton } from '@base/react'
import PerguntasService from '../../services/PerguntasService'
import './styles.scss'

export default function AddAssuntoModal(props) {
  const { open, onAction, setAllValuesOptions } = props
  const [assunto, setAssunto] = React.useState('')

  return (
    <Modal
      aria-labelledby='add-assunto-modal'
      open={open}
      onClose={() => { onAction() }}
      className='addAssunto-modal'
    >
      <div className='modal-container'>
        <div className='modal-container-title'>
          <span className='modal-title'>Adicionar assunto</span>
        </div>
        <div className='modal-input-container'>
          <input
            value={assunto}
            id='modal-input'
            className='modal-input'
            onChange={e => {
              setAssunto(e.target.value)
            }}
            placeholder='Digite aqui o assunto'
          />
        </div>
        <div className='modal-buttons-container'>
          <BaSeButton
            color='#2a9603'
            value={'Adicionar'}
            onClick={async () => {
              await PerguntasService.addAssunto({
                nome: assunto
              })
              const options = await PerguntasService.getOptions()
              setAllValuesOptions(options?.data)
              setAssunto('')
              onAction()
            }}
          />
        </div>
      </div>
    </Modal>
  )
}
